<div class="container">
  <div>
    <div class="head">
      {{ 'MENU_EDIT.HEADER' | translate }}
    </div>
      <a [routerLink]="['modifier-group']" mat-button>
        <span mat-menu-item>Modifier groups</span>
      </a>
      <a [routerLink]="['promo']" mat-button>
        <span mat-menu-item>Promo</span>
      </a>
  </div>

  <router-outlet></router-outlet>
</div>
